import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { AudioPlaylistPlayerModule } from 'src/app/common-components/audio-playlist-player/audio-playlist-player.module';
import { FileUrlPipeModule } from 'src/app/pipes/file-url-pipe/file-url-pipe.module';
import { FormatMailboxMessageCountPipeModule } from 'src/app/pipes/format-mailbox-message-count/format-mailbox-message-count-pipe.module';
import { FormatPhoneNumbersPipeModule } from 'src/app/pipes/format-phone-numbers/format-phone-numbers-pipe.module';
import { MailboxMessagesRegisterComponent } from './mailbox-messages-register.component';
import { MailboxMessageDetailEffects } from './state/mailbox-message-detail.effects';

@NgModule({
   declarations: [MailboxMessagesRegisterComponent],
   exports: [MailboxMessagesRegisterComponent],
   imports: [
      FormsModule,
      CommonModule,
      ReactiveFormsModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      ScrollingModule,
      MatSlideToggleModule,
      MatIconModule,
      MatButtonModule,
      MatMenuModule,
      FileUrlPipeModule,
      AudioPlaylistPlayerModule,
      EffectsModule.forFeature([MailboxMessageDetailEffects]),
      MatProgressSpinnerModule,
      MatTooltipModule,
      FormatMailboxMessageCountPipeModule,
      FormatPhoneNumbersPipeModule,
      MatFormFieldModule,
      MatSelectModule,
      AppRoutingModule,
   ],
})
export class MailboxMessagesRegisterModule {}
